import { indexableTables } from "./indexableTables.js";

export type IndexableTable = (typeof indexableTables)[number];

export function isIndexableTable(table: string): table is IndexableTable {
	return indexableTables.includes(table as IndexableTable);
}
